import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarComponent } from '../../core/layout/components/toolbar/toolbar.component';
import { FooterComponent } from '../../core/layout/components/footer/footer.component';

@Component({
  selector: 'app-signatory-list',
  standalone: true,
  imports: [CommonModule, ToolbarComponent, FooterComponent],
  templateUrl: './signatory-list.component.html',
  styleUrl: './signatory-list.component.scss',
})
export class SignatoryListComponent {}
